import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    emoji: '⚽',
    question: '¿Para quién es este producto?',
    answer: 'Este producto está pensado para jóvenes futbolistas y sus padres que quieren ayudar a sus hijos a fortalecer su mentalidad, gestionar la presión y desarrollar hábitos que los acompañen dentro y fuera de la cancha.'
  }, {
    emoji: '👦',
    question: '¿Para qué edades sirve?',
    answer: 'Es ideal para padres de niños y adolescentes que juegan al fútbol, especialmente desde edades en las que ya empiezan a vivir competencia, presión, frustración o miedo a equivocarse. Sin embargo, es útil para cualquier edad.'
  }, {
    emoji: '🧠',
    question: '¿Qué aprenderá mi hijo con este material?',
    answer: 'Aprenderá herramientas clave para trabajar aspectos como la confianza, la resiliencia, el manejo de errores, la concentración, la motivación y la fortaleza mental en el fútbol.'
  }, {
    emoji: '📚',
    question: '¿En qué formato viene?',
    answer: 'Viene en formato digital, para que lo puedas descargar y consultar desde tu móvil, tablet u ordenador.'
  }, {
    emoji: '🛡️',
    question: '¿Tiene garantía?',
    answer: 'Sí. Tu compra queda respaldada por la garantía indicada en esta misma página de venta.'
  }, {
    emoji: '📖',
    question: '¿Qué temas aborda este producto?',
    answer: 'Aborda temas fundamentales como presión competitiva, confianza, disciplina, resiliencia, motivación, manejo del error, concentración, visualización y apoyo familiar.'
  }, {
    emoji: '🏠',
    question: '¿Puedo usar este material en casa, aunque mi hijo entrene en un club?',
    answer: 'Sí. De hecho, está pensado para complementar lo que vive en el club y ayudarte a reforzar desde casa hábitos mentales positivos que muchas veces no se trabajan en profundidad.'
  }, {
    emoji: '😔',
    question: '¿Qué pasa si mi hijo está desmotivado o frustrado con el fútbol?',
    answer: 'Este material puede ayudarte a comprender mejor lo que está viviendo y a acompañarlo con herramientas más útiles. Es ideal para momentos en los que el niño siente miedo al error, frustración, ansiedad o falta de confianza.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 md:py-28 bg-[#f8f9fa]" data-id="element-28">
      <div className="max-w-3xl mx-auto px-5 sm:px-6 lg:px-8" data-id="element-29">
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="text-center mb-12 md:mb-16" data-id="element-30">
          <h2 className="text-3xl md:text-4xl font-heading text-brand-slate leading-tight" data-id="element-31">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-32">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="bg-white rounded-2xl border border-gray-100 overflow-hidden" data-id="element-33">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-5 sm:px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-34">
                <span className="font-medium text-brand-slate flex items-center gap-3 text-base md:text-lg" data-id="element-35">
                  <span className="text-xl flex-shrink-0" data-id="element-36">{faq.emoji}</span>
                  <span data-id="element-37">{faq.question}</span>
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-brand-slate-muted transition-transform duration-300 flex-shrink-0 ml-4 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-38" />
              </button>

              <AnimatePresence data-id="element-39">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-40">
                    <div className="px-5 sm:px-6 pb-5 pt-0 text-brand-slate-light pl-14 text-sm md:text-base leading-relaxed" data-id="element-41">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}